import axios from 'axios'

const axiosInstance = axios.create({
  baseURL: '/api',
  timeout: 3000,
})

axiosInstance.interceptors.request.use(
  (config) => {
    const token = JSON.parse(sessionStorage.getItem('jwt'))

    if (config.responseType === 'blob') {
      config.headers['Accept'] = 'application/pdf'
      //
      delete config.headers['Content-Type']
    } else {
      config.headers['Content-Type'] = 'application/json'
      config.headers['Accept'] = 'application/json'
    }

    if (token) {
      config.headers.Authorization = token
    }

    return config
  },
  (error) => Promise.reject(error)
)


axiosInstance.interceptors.response.use(
  (response) => {
    if (response.config.responseType === 'blob') {
      return response
    }
    return response.data
  },
  (error) => {
    if (error.response) {
      console.error('API Error:', error.response.status, error.response.data)
    } else if (error.request) {
      console.error('No response from server')
    } else {
      console.error('Request error:', error.message)
    }
    return Promise.reject(error)
  }
)

const vueAxios = {
  get: (url, config = {}) => axiosInstance.get(url, config),
  post: (url, data, config = {}) => axiosInstance.post(url, data, config),
  put: (url, data, config = {}) => axiosInstance.put(url, data, config),
  patch: (url, data, config = {}) => axiosInstance.patch(url, data, config),
  delete: (url, config = {}) => axiosInstance.delete(url, config),
  request: (config) => axiosInstance.request(config),
}

export default vueAxios
